export var KEY;
(function (KEY) {
    KEY[KEY["Enter"] = 13] = "Enter";
    KEY[KEY["Ctrl"] = 17] = "Ctrl";
    KEY[KEY["Esc"] = 27] = "Esc";
    KEY[KEY["Left"] = 37] = "Left";
    KEY[KEY["Up"] = 38] = "Up";
    KEY[KEY["Right"] = 39] = "Right";
    KEY[KEY["Down"] = 40] = "Down";
})(KEY || (KEY = {}));
//# sourceMappingURL=constants.js.map